module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_dadinho.20ec9282.png";